import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button/Button';

const Popup = ({ title, content, actions, position = 'top-6 left-3' }) => {
  return (
    <div className={`absolute ${position} z-[999] text-left no-underline bg-white border-2 border-blue-200 rounded-lg`}>
      <div className="p-5 px-7 w-[280px] box-content rounded-lg inline-block shadow-[0_4px_8px_0_rgba(0,0,0,0.2),0_6px_20px_0_rgba(0,0,0,0.19)] transition-all duration-[2s]">
        <div className="mb-4">
          {title && (
            <div className="font-semibold text-base leading-5 text-center">
              {title}
            </div>
          )}
          {content && (
            <div className="font-sans text-sm italic text-center mt-4 bg-sky-100 py-1.5 px-2 rounded-lg">
              {content}
            </div>
          )}
        </div>
        {actions && (
          <div className="flex gap-2">
            {actions.map((action, index) => (
              <Button
                key={index}
                label={action.label}
                onClick={action.onClick}
                modifier={action.modifier || 'primary'}
                className="!px-2.5 !py-2 !text-xs flex-1"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

Popup.propTypes = {
  title: PropTypes.node,
  content: PropTypes.node,
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  })),
  position: PropTypes.string,
};

export default Popup;
